import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Settings, DatabaseZap, RefreshCw } from 'lucide-react';
import { isOnStagingUrl } from '@/utils/featureFlags';

const MIGRATION_ALLOWED_EMAIL = 'platform+b@figfinance.io';

interface AdminNavProps {
  onRefresh?: () => void;
  isRefreshing?: boolean;
}

export function AdminNav({ onRefresh, isRefreshing }: AdminNavProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useAuth();
  const canMigrate = user?.email === MIGRATION_ALLOWED_EMAIL;

  return (
    <div className="flex items-center gap-2">
      {pathname !== '/admin' && (
        <Button
          onClick={() => navigate('/admin')}
          variant="ghost"
          className="flex items-center gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Admin
        </Button>
      )}

      <Button
        onClick={() => navigate('/settings')}
        variant={pathname === '/settings' ? 'default' : 'outline'}
        className="flex items-center gap-2"
      >
        <Settings className="h-4 w-4" />
        Settings
      </Button>

      {canMigrate && !isOnStagingUrl() && (
        <Button
          onClick={() => navigate('/admin/migrate')}
          variant={pathname === '/admin/migrate' ? 'default' : 'outline'}
          className="flex items-center gap-2"
        >
          <DatabaseZap className="h-4 w-4" />
          Migrate to Staging
        </Button>
      )}

      {onRefresh && (
        <Button
          onClick={onRefresh}
          disabled={isRefreshing}
          variant="outline"
          className="flex items-center gap-2"
        >
          <RefreshCw className={`h-4 w-4 ${isRefreshing ? 'animate-spin' : ''}`} />
          Refresh Data
        </Button>
      )}
    </div>
  );
}
